import { ActivitiesEnum } from "../../models/enum/ActivitiesEnum";

const activitiesRoutes = new Map<number, string>([
    [ActivitiesEnum.CheckIn, 'checking'],
    [ActivitiesEnum.Sales, 'salesAppointment'],
    [ActivitiesEnum.Inventory, 'inventoryAppointment'],
    [ActivitiesEnum.ShareOfShelf, 'shareOfShelf'],
    [ActivitiesEnum.CheckOut, 'checkout'],
    [ActivitiesEnum.ESFCoverage, 'esfCoverageAppointment'],
    [ActivitiesEnum.Survey, 'surveyByAppointment'],
    [ActivitiesEnum.VisualTrade, 'visualTrade'],
    [ActivitiesEnum.PriceShopping, 'pricesAppointment'],
    [ActivitiesEnum.ProductCoverage, 'productCoverage'],
    [ActivitiesEnum.POSLayout, 'posLayoutAppointment'],
    [ActivitiesEnum.Feedback, 'feedBack'],
    [ActivitiesEnum.VisualInventory, 'visualExecutionInventory'],
    [ActivitiesEnum.ClientsServed, 'servedClientsAppointment'],
    [ActivitiesEnum.StockOut, 'stockOutAppointment'],
    [ActivitiesEnum.ClosingSales, 'closingSalesAppointment'],



]);

export default activitiesRoutes;
